// extracted by mini-css-extract-plugin
export default {"input":"SearchInput_input__TDDRU","inputDisabled":"SearchInput_inputDisabled__+mJ6r"};